import { cn } from "@/lib/utils";
import { InputProps } from "./input.types";
import { forwardRef } from "react";
import { CalendarIcon } from "lucide-react";

export type Ref = HTMLInputElement;

export const Input = forwardRef<Ref, InputProps>((props, ref) => (
  <div>
    {props.showlabel && (
      <label
        className={`block text-sm font-medium leading-6 text-zinc-950 ${
          props.disable && "text-gray-300"
        }`}
      >
        {props.label}
      </label>
    )}

    <div className={cn("flex flex-col", !props.hasRemoveTopMargin && "mt-1")}>
      <div className="relative">
        {props.prefix && (
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <span className="text-slate-500 text-sm">{props.prefix}</span>
          </div>
        )}
        <input
          {...props}
          ref={ref}
          className={cn(
            `block w-full rounded-md border-0 py-1.5 text-zinc-950 shadow-sm ring-1 ring-inset ring-zinc-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-3 disabled:ring-zinc-100 disabled:bg-gray-100 disabled:border disabled:border-gray-200 ${props.style}`,
            props.prefix && "pl-8",
            props.className,
            props.alternativeCalendarIcon &&
              "[&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-y-0 [&::-webkit-calendar-picker-indicator]:right-0 [&::-webkit-calendar-picker-indicator]:w-1/2 [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:cursor-pointer",
          )}
          placeholder={props.placeholder || ""}
          disabled={props.disable}
          step={props.step}
        />
        {props.alternativeCalendarIcon && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <CalendarIcon className="h-4 w-4 text-black" />
          </div>
        )}
      </div>
      {props.error && (
        <p className="mt-2 text-sm text-red-600 dark:text-red-500">
          {props.error}
        </p>
      )}
    </div>
  </div>
));
Input.displayName = "Input";
